<template>
	<div style="max-width: 1140px;">
		<div class="skipass-card grid-x grid-margin-x">
			<!-- Image -->
			<div class="cell small-12 medium-4 large-3">
				<img
					class="skipass-card__image"
					:src="getImgUrl(cardData.imageUrl)"
					:alt="cardData.name"
				/>
			</div>

			<!-- Description & dropdowns -->
			<div class="cell small-12 medium-9 large-9">
				<h2>
					<strong>{{ cardData.name }}</strong>
					<span v-if="cardData.displayLength">
						, {{ cardData.displayLength }}
					</span>
				</h2>
				<span v-if="cardData.description != ''">
					{{ cardData.description }}
				</span>
				<div class="skipass-card__group">
					<div
						v-for="ageGroup in cardData.ages"
						:key="ageGroup.key"
						class="skipass-card__group-item"
						:class="{
							'skipass-card__group-item--discount': ageGroup.isDiscount
						}"
					>
						<span class="skipass-card__group-age">
							<strong>{{ ageGroup.name }}</strong>
							({{ formatAgeSpan(ageGroup.fromAge, ageGroup.toAge) }})
						</span>
						<span
							class="skipass-card__group-price"
							v-if="ageGroup.isDiscount === false"
						>
							{{ convertPrice(ageGroup.price) }} SEK
						</span>
						<span class="skipass-card__group-price" v-if="ageGroup.isDiscount">
							<span class="label-box-wrapper">
								<span>{{ convertPrice(ageGroup.price) }} SEK</span>
								<LabelBox>
									<template>
										-{{ convertPrice(ageGroup.ordinaryPrice - ageGroup.price) }}
										SEK
									</template>
								</LabelBox>
							</span>
							<span class="skipass-card__group-price__full">
								<span class="skipass-card__group-price__full__label">
									Ord. pris
								</span>
								&nbsp;{{ convertPrice(ageGroup.ordinaryPrice) }} SEK
							</span>
						</span>
						<SelectArray
							:data="{
								id: ageGroup.id,
								type: 'skipass',
								index: index,
								poollid: ageGroup.poollid,
								ageGroup: ageGroup.name,
								ordinaryPrice: ageGroup.ordinaryPrice,
								promotion: ageGroup.promotion,
								price: ageGroup.price,
								fromAge: ageGroup.fromAge,
								toAge: ageGroup.toAge,
								displayLength: cardData.displayLength,
								startDate: ageGroup.startDate,
								endDate: ageGroup.endDate,
								name: cardData.name,
								length: cardData.length,
								pricecode: ageGroup.pricecode,
								image: getImgUrl(cardData.imageUrl),
								periodOfValidity: setValidity(
									cardData.skipassType,
									ageGroup.startDate
								),
								keycardPrice: keycardPrice,
								photoMandatory: ageGroup.photoMandatory,
								connected: ageGroup.connected
							}"
							:id="10000"
							:placeholder="$t('skipass.placeholderQuantity')"
							:defaultSelectedValue="selectedQuantity"
							:option-items="quantityArray"
							:lightTheme="true"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '../../mixin'
import moment from 'moment'

import LabelBox from '../atoms/LabelBox'
import SelectArray from '../atoms/SelectArray'

export default {
	name: 'SkipassCard',
	mixins: [mixin],
	components: {
		SelectArray,
		LabelBox
	},
	data() {
		return {}
	},
	props: {
		cardData: {
			type: Object,
			default: () => {}
		},
		keycardPrice: {
			type: Number,
			default: 0
		},
		index: {
			type: Number
		}
	},
	methods: {
		setValidity(type, startdate) {
			moment.locale('sv')
			var length = this.cardData.length - 1
			var startDate = moment(startdate).format('dddd D MMM YYYY')
			var endDate = moment(startdate).add(length, 'd').format('dddd D MMM YYYY')
			//var startYear = moment(startdate).format('YYYY')
			//var endYear = moment(startdate).add(length, 'd').format('YYYY')

			//Skipass 1-14 dagar
			if (type < 15) {
				if (startDate == endDate) {
					return startDate
				} else {
					return startDate + ' ' + this.$t('search.to') + ' ' + endDate
				}
				//förmiddag samt eftermiddag
			} else if (type == 17 || type == 18) {
				return startDate
				//Skipass säsong samt valfria dagar/säsong
			} else if (type == 15 || type == 20 || type == 21) {
				return this.$t('skipass.seasonPeriod')
				//Ska år skrivas ut??
			}
		}
	}
}
</script>

<style lang="scss">
.skipass-card {
	padding: 35px 0;
	position: relative;
	&:after {
		content: '';
		display: block;
		position: absolute;
		bottom: 0;
		width: calc(100% - 4rem);
		border-bottom: 1px solid #d4d8df;
		margin-left: 2rem;
		margin-right: 2rem;
	}

	h2 {
		font-size: 28px;
		line-height: 1.2;
		color: #434449;
		margin: 16px 0;

		strong {
			font-weight: 500;
		}

		@include large-up {
			margin: -6px 0 16px;
		}
	}

	&__image {
		max-width: 100%;
		float: left;
	}

	&__group {
		display: flex;
		flex-wrap: wrap;
		margin-top: 0px;
		margin-left: -30px;
		overflow: hidden;

		@include for-phone-only {
			gap: 20px;
			margin-left: 0;
		}

		@include for-tablet-portrait-up {
			margin-top: 35px;
		}
	}
	&__group-item {
		display: flex;
		flex-direction: column;
		//float: left;
		padding: 0 30px;
		margin-top: 20px;

		&:last-child {
			border-right: 0;
			padding-right: 0;
		}

		@include for-phone-only {
			padding: 0;
		}

		@include for-tablet-portrait-up {
			margin-top: 0px;
			border-right: 1px solid #d4d8df;
		}

		&--discount {
			.skipass-card {
				&__group-price {
					display: flex;
					align-items: flex-start;
					flex-direction: column;

					.label-box {
						font-size: 14px;
						line-height: 15px;
						margin-left: 0.5rem;
					}

					&__full {
						color: #697791;
						font-size: 11px;
						font-weight: 500;
						letter-spacing: 0;
						line-height: 17px;
						display: flex;
						justify-content: flex-end;
						align-items: flex-end;

						&__label {
							color: $colorPrimary4;
						}
					}

					@include for-phone-only {
						flex-flow: column;
					}
				}
			}
		}
	}
	&__group-age {
		display: block;
		color: #434449;
		font-family: Saira;
		font-size: 14px;
		font-weight: 300;
		line-height: 22px;
		margin-bottom: 5px;
		strong {
			font-weight: 500;
		}
	}
	&__group-price {
		color: #434449;
		font-family: Saira;
		font-size: 22px;
		font-weight: 500;
		letter-spacing: 0;
		line-height: 28px;
	}
	.select__container {
		margin-top: auto;
		.select {
			min-width: 120px;
		}
	}
	.label-box-wrapper {
		align-items: center;
		display: flex;
	}
}
.transition-list-item:last-child .skipass-card:after {
	display: none;
}
</style>
